import LanguageCreateForm from "./language-create-form";
import LanguageEditForm from "./language-edit-form";
import LanguageDeleteForm from "./language-delete-form";
import LanguageFormFields from "./fields";


const LanguageForms = {
    Create: LanguageCreateForm,
    Edit: LanguageEditForm,
    Delete: LanguageDeleteForm,
    Fields: LanguageFormFields,
};

export default LanguageForms;
